export const LABOR_FLOWSHEET_DRAWER_MODES = {
  QuickAdd: "quick-add",
  Edit: "edit",
} as const;

export type LaborFlowsheetDrawerMode =
  (typeof LABOR_FLOWSHEET_DRAWER_MODES)[keyof typeof LABOR_FLOWSHEET_DRAWER_MODES];

export const LABOR_FLOWSHEET_SUBMIT_BUTTON_TEXT = {
  AddToFlowsheet: "Add To Flowsheet",
  Update: "Update",
} as const;
